/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AuthPostLogout = {
  id: 'authentication.logout.post',
  tag: 'Authentication',
  summary: 'Logout User',
  description: 'Users logout',
  flags: { isAuthorized: true },
  method: 'post',
  route: () => `/authentication/logout`,
  request: {},
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.object({}).optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
